export default class Animation {
    

    toggleActive() {

        function scrollTrigger(selector){
            let els = document.querySelectorAll(selector);
            let options = {};
            els = Array.from(els);
            els.forEach(el => {
                options = {
                    threshold: el.getAttribute('animation-threshold') ? parseFloat( el.getAttribute('animation-threshold') ) : 1,
                    reverse: el.getAttribute('animation-reverse') ? true : false,
                }
                addObserver(el, options)
            })
        }

        function addObserver(el, options){
            if(!('IntersectionObserver' in window)){
                entry.target.classList.add('active')
                return
            }
            let observer = new IntersectionObserver((entries, observer) => { //this takes a callback function which receives two arguments: the elemts list and the observer instance
                entries.forEach(entry => {
                    if(entry.isIntersecting) {
                       
                        entry.target.classList.add('active')
                        
                        if(!options.reverse) {
                            observer.unobserve(entry.target);
                        }
                    }
                    else if(options.reverse) {
                        entry.target.classList.remove('active')
                    }
                })
            }, options)
            observer.observe(el)
        }


        scrollTrigger('.animation');
    }

  
    init() {
        document.querySelector('.animation') ? this.toggleActive() : null;
    }
}